import { isInBlackFridayWeek } from '../utils/util';

export const NALOG_API = import.meta.env.VITE_NALOG_API;
export const NALOG = import.meta.env.VITE_NALOG;
export const NALOG_CLIENT = import.meta.env.VITE_NALOG_CLIENT_ID ?? 'market';
export const PUBLIC_API = import.meta.env.VITE_PUBLIC_API;
export const IMAGE_BASE_URL = import.meta.env.VITE_IMAGE_BASE_URL;
export const LOGIN_REDIRECT = import.meta.env.VITE_LOGIN_REDIRECT;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const APP_BASE = import.meta.env.VITE_APP_BASE;
export const SAVE_ALL_COUPONS_VISIBLE = import.meta.env
  .VITE_SAVE_ALL_COUPONS_VISIBLE;
export const DAILY_PRIZE_MODAL_VISIBLE = import.meta.env
  .VITE_DAILY_PRIZE_MODAL_VISIBLE;
export const END_OF_GAME_MODAL_VISIBLE = import.meta.env
  .VITE_END_OF_GAME_MODAL_VISIBLE;
export const GAME_RESULTS_MODAL_VISIBLE = import.meta.env
  .VITE_GAME_RESULTS_MODAL_VISIBLE;
export const CAPTCHA_SITE_KEY = import.meta.env.VITE_CAPTCHA_SITE_KEY;
export const ADVANTAGE_APP_LINK =
  import.meta.env.VITE_ADVANTAGE_APP_LINK ??
  'http://ytl.rs/ya?utm_source=shopping.yettel.rs&utm_medium=yettel_advantage_homepage&utm_content=coupon_details';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;
export const CURRENT_OFFERS_TITLE =
  import.meta.env.VITE_BLACK_FRIDAY && isInBlackFridayWeek()
    ? import.meta.env.VITE_BLACK_FRIDAY
    : 'Aktuelno';
export const QUIZ_START = import.meta.env.VITE_QUIZ_START
  ? Number(import.meta.env.VITE_QUIZ_START)
  : null;
export const QUIZ_END = import.meta.env.VITE_QUIZ_END
  ? Number(import.meta.env.VITE_QUIZ_END)
  : null;
